module.exports = __webpack_public_path__ + "static/media/post.fe8b762e.svg";